import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import ReactDOM from 'react-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';
import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Fehlmann extends Component {

  getCurrentDate(){
    var today = new Date(),
            returnVal =  today.getFullYear() + '' + ((today.getMonth() + 1)<10? '0' + (today.getMonth() + 1):(today.getMonth() + 1)) + '' + ((today.getDate())<10? '0' + (today.getDate()):(today.getDate()));
    return returnVal;
  }

  render() {
    var dataNews;
    var builtTmpNews;
    var parseStringNews = require('xml2js').parseString;
    fetch('/newsData.xml')
    .then((r) => r.text())
    .then(text  => {
      parseStringNews(text, function (err, result) {
          dataNews=result;
          var tmpOV = JSON.parse(JSON.stringify(result));
          dataNews= tmpOV.NewsList.News;
          var newDataNews = [];
          for (var ele in dataNews) {
            if (dataNews[ele].Supplier[0].includes("Fehlmann")){
              newDataNews.push(dataNews[ele]);
            }
          }
          dataNews = newDataNews;
          builtTmpNews = dataNews.map((element) =>
                <Col xs={12} sm={6} md={4} lg={3} className="newsItem">
                  <div className="newsCont news-supplier">
                    <img src={`../news/${element.Image}`} alt={element.Title} id={`image ${element.Title}`} className={`newsImg${element.classType}`} />
                    <video id="background-video" className={`newsVideo${element.classType}`} loop autoPlay playsInLine="true">
                        <source src={`../videos/${element.FileShort}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    <h4>{element.Title}</h4>
                    <h5>{element.Supplier}</h5>
                    <hr/>
                    <p className="newsText">{element.Text}</p>
                    <hr/>
                    <p className="newsDate">{element.Date}</p>
                  </div>
                </Col>

              );
          }.bind(this));
          this.builtElement = ReactDOM.render(builtTmpNews, document.getElementById('newsRoot'));
      });
      var dataFairs;
      var builtTmpFairs;
      var parseStringFairs = require('xml2js').parseString;
      fetch('/fairData.xml')
      .then((r) => r.text())
      .then(text  => {
        parseStringFairs(text, function (err, result) {
          dataFairs=result;
            var tmpOV = JSON.parse(JSON.stringify(result));
            dataFairs= tmpOV.Fairs.Fair;
            const todayDate = Number(this.getCurrentDate());
            var newDataFairs = [];
            for (var ele in dataFairs) {
              for (var exhib in dataFairs[ele].Exhibitors[0].Exhibitor) {
                if (dataFairs[ele].Exhibitors[0].Exhibitor[exhib].Link.includes("Fehlmann")){
                  newDataFairs.push(dataFairs[ele]);
                }
              }
            }
            dataFairs = newDataFairs;
            builtTmpFairs = dataFairs.map((element) =>{
              return Number(element.Year + '' + element.MonthEnd + '' + element.DayEnd)>todayDate?
                  <Col xs={12} sm={6} md={4} lg={3} className="newsItem">
                    <div className="newsCont news-supplier">
                      <img src={`../fairs/${element.Image}`} alt={element.Title} id={`image ${element.Name}`} className={`newsImgimageLowRes`} />
                      <h4>{element.Name}</h4>
                      <h5>{element.Location} | {element.DM}.{element.Year}</h5>
                      <hr/>
                      <p className="newsText">{element.Desc}</p>
                    </div>
                  </Col>

            : <div></div>});
            }.bind(this));
            this.builtElement = ReactDOM.render(builtTmpFairs, document.getElementById('fairsRoot'));
        });
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/WuF">WuF</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Fehlmann</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Fehlmann Headquater" />
        </div>
        <div className="supMainTextLS">
          <h1>Fehlmann</h1>
          <Grid className="supMainInfo">
            <Row>
              <Col xsHidden smHidden md={5}>
                <Carousel  controls={false} interval={3000}>
                  <Carousel.Item >
                      <img  src={InfoJumb1}  alt="Fehlmann Picomax 75"  height="100%" />
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb2} alt="Fehlmann Picomax 95"  height="100%"/>
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb3} alt="Fehlmann Versa"  height="100%" />
                  </Carousel.Item>
                </Carousel>
                </Col>
              <Col xsHidden md={7}>
                <h4>Das Familienunternehmen Fehlmann AG entwickelt und produziert Präzisions-Werkzeugmaschinen fürs Fräsen und Bohren. Seit ihrer Gründung im Jahre 1930 wurden über 12000 Werkzeugmaschinen weltweit ausgeliefert. Entwicklung, Produktion und Montage erfolgen mit über 180 Mitarbeitenden ausschliesslich im Stammwerk Seon/Schweiz. Bei Fehlmann wird nicht nur montiert. Auf modernsten Produktionsanlagen werden Teile und Baugruppen mit hoher Fertigungstiefe in optimal aufeinander abgestimmter Präzision produziert. Durch die Zertifizierung des Qualitäts- und Umweltmanagements nach den neusten Normen ISO 9001:2015 und 14001:2015 wird der kontinuierliche Verbesserungsprozess in allen Unternehmensbereichen gewährleistet und eine umweltbewusste, nachhaltige Produktion sichergestellt. Höchste Qualität, Präzision und Nachhaltigkeit, sowie auch eine hohe Verfügbarkeit sind somit garantiert.
              </h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>
                <h4>Das Familienunternehmen Fehlmann AG entwickelt und produziert Präzisions-Werkzeugmaschinen fürs Fräsen und Bohren. Seit ihrer Gründung im Jahre 1930 wurden über 12000 Werkzeugmaschinen weltweit ausgeliefert.
              </h4>
              </Col>
              <Col xs={12} md={{ span: 7, offset: 2 }}>
                <Button className="supMainButtonWebPage" variant="light" href="https://www.fehlmann.com/" target="_blank">Hersteller Homepage</Button>
              </Col>
            </Row>
          </Grid>
        </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid className="shortDesc">
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Höchste Präzision</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Swiss Made</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Innovative Lösungen und Flexibilität</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Durchdachte Maschinenkonzepte</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h5>&#9658; &nbsp; Höchste Präzision</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h5>&#9658; &nbsp; Swiss Made</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Innovative Lösungen und Flexibilität</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Durchdachte Maschinenkonzepte</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <center>
          <h1>Produkte</h1>
          </center>
          <Row className="show-grid">
            <Col  xs={12} sm={6}>
              <center>
                <div className="productsButton">
                  <Link to="/Suppliers/Fehlmann/Picomax"><h4 className="buttonBlue">Picomax</h4>
                    <h5>Die Fehlmann Picomax Serie bietet vielseitige und kompakte Bearbeitungszentren, ideal für die präzise Einzelteil- und Kleinserienfertigung sowie für Ausbildungszwecke, mit flexiblen Ausbaumöglichkeiten bis hin zur 5-Achs-Bearbeitung und Automatisierung.</h5>
                    <p>Mehr ...</p>
                  </Link>
                </div>
            </center>
            </Col>
            <Col  xs={12} sm={6}>
              <center>
                <div className="productsButton">
                  <Link to="/Suppliers/Fehlmann/Versa"><h4 className="buttonBlue" >Versa</h4>
                    <h5>Die Fehlmann Versa Serie umfasst hochpräzise Portalbearbeitungszentren, die sich durch hohe Stabilität, exzellente Zugänglichkeit und optimale Voraussetzungen für die automatisierte Bearbeitung auch großer und komplexer Werkstücke auszeichnen.</h5>
                    <p>Mehr ...</p>
                  </Link>
                </div>
            </center>
            </Col>

          </Row>

        </Grid>
        <br/>
      </section>
      <hr/>
      <div className='container-fluid'>
      <section>
        <br/>
        <center>
          <h1>Messen</h1>
        </center>
        <br/><br/>
        <center>
          <div className="newsAtSupplier" id="fairsRoot"/>
        </center>
        <br/><br/><br/>
      </section>
      </div>
      <hr/>
      <div className='container-fluid'>
      <section>
        <br/>
        <center>
          <h1>News</h1>
        </center>
        <br/><br/>
        <center>
          <div className="newsAtSupplier" id="newsRoot"/>
        </center>
        <br/><br/><br/>
      </section>
      </div>
      </div>
    );
  }
}

export default Fehlmann;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/fehlmann/mainPageSup.js